import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { InformationCircleIcon, LockClosedIcon } from '@heroicons/react/24/outline'

import { ConsentCheckbox } from '../ConsentCheckbox'
import { ConsentSection } from '../ConsentSection'
import { ConsentSectionFieldsProps } from '../types'

export function SecondaryDataConsentSection({ consents, updateConsent }: ConsentSectionFieldsProps) {
  return (
    <ConsentSection title={t`Use of Your Data`}>
      <div className="flex items-start gap-3 rounded-lg bg-gray-100 p-3">
        <LockClosedIcon className="mt-0.5 h-5 w-5 text-gray-500" aria-hidden="true" />
        <div>
          <p className="text-sm text-gray-900">
            <Trans>Processing of your data for care</Trans>
          </p>
          <p className="text-xs text-gray-500">
            <Trans>Required for the consultation to take place</Trans>
          </p>
        </div>
      </div>

      <ConsentCheckbox
        name="dataForResearch"
        label={t`I authorize the anonymized use of my data for medical research`}
        checked={consents.dataForResearch}
        onChange={(checked) => updateConsent('dataForResearch', checked)}
        description={t`Your data will be anonymized before use`}
      />
      <ConsentCheckbox
        name="dataForServiceImprovement"
        label={t`I authorize the use of my data to improve the service`}
        checked={consents.dataForServiceImprovement}
        onChange={(checked) => updateConsent('dataForServiceImprovement', checked)}
        description={t`Helps improve the quality of our services`}
      />

      <div className="flex items-start gap-2 rounded-lg border border-blue-200 bg-blue-50 p-3">
        <InformationCircleIcon className="mt-0.5 h-4 w-4 text-blue-600" aria-hidden="true" />
        <p className="text-xs text-blue-900">
          <Trans>These options are optional. You can decline them without affecting your access to the service.</Trans>
        </p>
      </div>
    </ConsentSection>
  )
}
